var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24.284mm",
    height: "24.284mm",
    viewBox: "16.858162 -184.141846 24.283676 24.283676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,0)",
    style: {
      stroke: "none",
      fill: "#ffffff",
      fillRule: "evenodd"
    },
    d: "M36.665421,176.863373C36.300606,177.228134,35.709206,177.228134,35.344391,176.863373C34.979759,176.498642,34.979759,175.907272,35.344391,175.542542L37.953018,172.934006L25.26405,172.934006C24.748226,172.934006,24.330063,172.515839,24.330063,172.000015C24.330063,171.484192,24.748226,171.066025,25.26405,171.066025L37.953018,171.066025L35.344391,168.457489C34.979759,168.092743,34.979759,167.501389,35.344391,167.136551C35.709206,166.771927,36.300606,166.771927,36.665421,167.136551L40.868366,171.339584C41.232994,171.70433,41.232994,172.2957,40.868366,172.660431L36.665421,176.863373z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,0)",
    style: {
      stroke: "none",
      fill: "#ffffff",
      fillRule: "evenodd"
    },
    d: "M18.726137,184.141846C17.694473,184.141846,16.858162,183.305527,16.858162,182.27388L16.858162,161.726151C16.858162,160.694473,17.694492,159.85817,18.726137,159.85817L32.73595,159.85817C33.251701,159.85817,33.669937,160.276413,33.669937,160.79216C33.669937,161.307907,33.251701,161.726151,32.73595,161.726151L18.726137,161.726151L18.726137,182.27388L32.73595,182.27388C33.251701,182.27388,33.669937,182.692047,33.669937,183.20787C33.669937,183.723694,33.251701,184.141846,32.73595,184.141846L18.726137,184.141846z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.48fca374209ca547026752a72d282e1c.svg";
export { ForwardRef as ReactComponent };